import {createReducer, on} from '@ngrx/store';
import {UserSettings} from 'app/global/user-settings.dto';
import {LocalStorageKeys} from '../../global/storage.service';
import {HttpActionState} from '../../main/pages/users/userslisting/store/users-listing.reducers';
import * as AuthActions from '../actions/auth.action';

export interface AuthState {
  userData: UserSettings;
  userSettings: UserSettings;
  error: string;
  loading: boolean;
  crmData: CrmData;
  isThirdPartyLogin: boolean;
  userDataFetchStatus: HttpActionState;
  loginSuccess: boolean;
  refreshSessionInProgress:HttpActionState;
  verifyOtpInProgress: HttpActionState;
  iframeableLoginIn: boolean
}

export interface CrmData {
  payload: string
  provider: string
  iscrmlogin: number
}

export interface CrmData2  {
  payload: Payload
  provider: string
  iscrmlogin: number
}

export interface Payload {
  id: string
  type: string
  entity_name: string
  email: string
  access_token: string
  product_name: string
  logged_in_user: string
}

export const initialState: AuthState = {
  userData: null,
  userSettings: null,
  error: null,
  loading: false,
  crmData: null,
  isThirdPartyLogin: false,
  userDataFetchStatus: HttpActionState.Init,
  loginSuccess: false,
  refreshSessionInProgress: HttpActionState.Init,
  verifyOtpInProgress: HttpActionState.Init,
  iframeableLoginIn: false
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.loadAuthData, state => {
    const userData = localStorage.getItem(LocalStorageKeys.USER);
    return userData ? { ...state, userData:  JSON.parse(userData) as UserSettings }  : state;
  }),
  
  on(AuthActions.loadCrmData, (state, {crmData}) => {
    return {
      ...state,
      crmData: crmData,
      isThirdPartyLogin: true
    }
  }),

  on(AuthActions.verifyOtp, (state) => {
    return {
      ...state,
      verifyOtpInProgress: HttpActionState.Busy
    }
  }),

  on(AuthActions.verifyOtpSuccess, (state) => {
    return {
      ...state,
      verifyOtpInProgress: HttpActionState.Done
    }
  }),

  on(AuthActions.verifyOtpFailure, (state) => {
    return {
      ...state,
      verifyOtpInProgress: HttpActionState.Failed
    }
  }),

  on(AuthActions.login, (state) => ({
    ...state,
    loading: true
  })),

  on(AuthActions.loginSuccess, (state, { userData, isThirdPartyLogin }) => ({ 
    ...state, 
    userData,
    loading: false,
    isThirdPartyLogin: isThirdPartyLogin,
    loginSuccess: true,
  })),

  on(AuthActions.markAsLoogedIn, (state)=>({
      ...state,
      loginSuccess: true
  })),

  on(AuthActions.logoutSuccess, (state)=>({
      ...state,
      loginSuccess: false
  })),
 
  on(AuthActions.clearState, () => ({
      ...initialState
  })),
  
  on(AuthActions.loginFailure, (state, { error }) => ({ ...state, error, loading: false, loginSuccess: false })),
  on(AuthActions.addUserSettings, (state, { userSettings }) => ({ ...state, userSettings })),
  on(AuthActions.fetchUserData, (state)=>({
      ...state,
      userDataFetchStatus: HttpActionState.Busy
  })),

  on(AuthActions.fetchUserDataSucceeded, (state, {userData})=>({
      ...state,
      userData:userData,
      userDataFetchStatus: HttpActionState.Done,
      loginSuccess: true
  })),
  on(AuthActions.fetchUserDataFailed, (state)=>({
      ...state,
      userDataFetchStatus: HttpActionState.Failed,
      loginSuccess: false
  })),
  on(AuthActions.swtichAndRedirectUser, (state)=>({
          ...state,
          userDataFetchStatus: HttpActionState.Busy,
      }
  )),
  on(AuthActions.swtichAndRedirectUserSuccess, (state,  {userData})=>({
          ...state,
          userDataFetchStatus: HttpActionState.Done,
          loginSuccess: true,
          userData:userData,
      }
  )),
  on(AuthActions.swtichAndRedirectUserFail, (state)=>({
          ...state,
          userDataFetchStatus: HttpActionState.Failed,
          loginSuccess: false
      }
  )),
  on(AuthActions.refreshSession, (state)=>({
       ...state,
       refreshTokenInProgress: HttpActionState.Busy
   })),
  on(AuthActions.refreshSessionSuccess, (state)=>({
       ...state,
       refreshTokenInProgress: HttpActionState.Done
   })),
  on(AuthActions.setIframeState, (state, {isIframeable})=>({
       ...state,
       iframeableLoginIn: isIframeable
   })),
  on(AuthActions.refreshSessionFailed, (state)=>({
       ...state,
       refreshSessionInProgress: HttpActionState.Failed
   })),

   // when SSO flow starts
  on(AuthActions.ssoLogin, (state) => ({
      ...state,
      loading: true,
      error: null
  })),

  // when backend returned redirect url (we redirect browser separately)
  on(AuthActions.ssoLoginSuccess, (state) => ({
      ...state,
      loading: false
  })),

  // if something failed during SSO initiation
  on(AuthActions.ssoLoginFailure, (state, { error }) => ({
      ...state,
      error,
      loading: false,
      loginSuccess: false
  })),

  // support clearing inline errors without wiping whole auth state
  on(AuthActions.clearAuthError, (state) => ({
      ...state,
      error: null
  })),
);
